import {FieldValidator} from './validator.interface';
export const MIN_PASSWORD_LENGTH = 8;
export const MIN_INSTA_USERNAME_LENGTH = 2;

export const validateRequired = <T = unknown>(value: T) => !value ? {required: true} : undefined;

export const validateDefined = <T = unknown>(value: T) => value === undefined ? {defined: true} : undefined;

export const validateRequiredTrue: FieldValidator<boolean | undefined | null> = value => value !== true ? {requiredTrue: true} : undefined;

export const validateMinLength: FieldValidator<string> =
    value => value && value.length < MIN_PASSWORD_LENGTH ? {minLength: true} : undefined;

export const validateMinInstaUsernameLength: FieldValidator<string> =
    value => value && value.length < MIN_INSTA_USERNAME_LENGTH ? {minInstaUsernameLength: true} : undefined;

export const validateComplexity: FieldValidator<string> =
    value => value && (value.match(/[$&+,:;=?@#|'<>.^*()%!-]/) != null) ? undefined: {complexity: true} ;

// tslint:disable-next-line:max-line-length
// eslint-disable-next-line
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const validateEmail: FieldValidator<string> = value => {
    if (!value) {
        return undefined;
    } else {
        return value.match(emailRegex) === null ? {email: true} : undefined;
    }
};
//function that gets a value and returns a function that checks if value matches
export const createMatchValidator = (source: string) => (value: string) => value === source ? undefined : {passMatch: true};
export const validatePasswordsMatch: FieldValidator<[string, string]>  = value => value[0] === value[1] ? undefined : {passMatch: true};

export const validateNoSpecialChars: FieldValidator<string> =
    value => value && (value.match(/^[a-zA-Z0-9]*$/) === null) ? {noSpecialChars: true} : undefined;

export const validatePositiveNumber: FieldValidator<number> =
    value => value && value <= 0 ? {positiveValue: true} : undefined;

export const validateNonNegativeNumber: FieldValidator<number> =
    value => value < 0 ? {nonNegativeValue: true} : undefined;

export const validatePercentage: FieldValidator<number> =
    value => value && (value <= 0 || value > 100) ? {validPercentage: true} : undefined;

export const validateInteger: FieldValidator<number> =
    value => value && !(value % 1 === 0) ? {validInteger: true} : undefined;

export const validateRequiredDefined: FieldValidator<boolean> = value => value === undefined ? {requiredDefined: true} : undefined;
